import { Component, ViewChild, OnInit, Input, OnChanges, Inject } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import {usersResultService} from '../usersResultService';
// import {PagedData} from "./datatable/paged-data";
import {Page} from "./datatable/page";
import { MatDialog,MatDialogRef  } from '@angular/material/dialog';
import { dialogComponent } from '../dialog/dialog.component';
// import { DaterangepickerConfig } from 'ng2-daterangepicker';
// import { filter } from 'rxjs/operators/filter';
// import { SelectComponent } from 'ng2-select'
import { CommonService } from '../shared/services/common.service';
import { APPCONFIG } from '../config'
import { FormControl } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Component({
    selector: 'configsListComponent',
    template: require('./configsList.component.html'),
    providers: [HttpService,SessionHandler]
})

export class ConfigsListComponent {
    ipp: number = 10;

itemsPerPage= new FormControl(100);
@ViewChild('tableWrapper') tableWrapper;
@ViewChild(DatatableComponent) table: DatatableComponent;


    APPCONFIG;
    tableRows :any = [];
    page = new Page();
    public rows:any;
    dashboardData = [];
    temp = [];
    showTable:boolean = true;
    userData:any;
    dialogRef;
    reasonList:any;
    fileUrl:any;
    isApprover:boolean = false;
    showAction:boolean = false;
    isFS:boolean = false;
    isAdmin:boolean = false;
    public daterange: any = {};
    filters:any={};
    customFilters:any={};
    arrayKeys:any;
    showFilterList:boolean = false;
    userRole:any;
    isOTD:boolean = false;
    showLoader = false;
    siteId:any = undefined;
    private currentComponentWidth;
    rowToDel:string = null;
    
    
    ngAfterViewChecked() {
        // Check if the table size has changed,
        if (this.table && this.table.recalculate && (this.tableWrapper.nativeElement.clientWidth !== this.currentComponentWidth)) {
          this.currentComponentWidth = this.tableWrapper.nativeElement.clientWidth;
          this.table.recalculate();
        //   this.cdr.detectChanges();
        }
      }

    pageLimit(limit:any): void {
        this.changePageLimit(limit);
        this.table.limit = this.ipp;
        this.table.recalculate();

        setTimeout(() => {
            if (this.table.bodyComponent.temp.length <= 0) {
              this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
            }
          });
      }

      private changePageLimit(limit: any): void {
        this.ipp = parseInt(limit, 10);
      }
    
    onPage(event) {
        this.table.limit = Number(this.itemsPerPage.value);
      }

      constructor(
        private router: Router,
        private http: HttpService,
        private serverResultsService: usersResultService,
        private activatedRoute: ActivatedRoute,
        private sessionHandler: SessionHandler,
        public dialog: MatDialog,
        private commonService: CommonService,
        private oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    ) {
        this.page.pageNumber = 0;
        this.page.size = 10;
        // Subscribe to Okta auth state instead of using angularx-social-login's authService
        this.oktaAuthStateService.authState$.subscribe(async (authState) => {
            if (authState.isAuthenticated) {
                // Retrieve the Okta token and store it for subsequent API calls
                const tokens = await this.oktaAuth.tokenManager.getTokens();
                this.accessToken = tokens.accessToken?.accessToken;
                // Set up date ranges based on today's date
                const today = new Date();
                this.daterange.date = today.getDate();
                if (today.getMonth() === 0 || today.getMonth() === 1) {
                    this.daterange.start_mm = 12;
                    this.daterange.end_mm = 2;
                    this.daterange.startYear = today.getFullYear() - 1;
                    this.daterange.endYear = today.getFullYear();
                } else {
                    this.daterange.start_mm = today.getMonth() - 1;
                    this.daterange.end_mm = today.getMonth() + 1;
                    this.daterange.startYear = today.getFullYear();
                    this.daterange.endYear = today.getFullYear();
                }
                // Retrieve any query parameters (like siteId) from the activated route
                this.activatedRoute.queryParams.subscribe((params: Params) => {
                    this.siteId = params['siteId'];
                });
                // Prepare filter criteria and load dashboard data
                this.filters['offSet'] = this.page.pageNumber * this.page.size;
                this.getDashboardData(this.filters);
                this.commonService.setData(null);
            } else {
                // Redirect to login if user is not authenticated
                this.router.navigateByUrl('/extra/login');
            }
        });
    }
     

    public reloadData(){
        this.getDashboardData(this.filters);
    }

    accessToken: string;
  
    public getDashboardData(filter) {
        this.showLoader = true;
        let token = localStorage.getItem('userEmail');
        var httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token
                'Authorization': `Bearer ${this.accessToken}`,

            })
        
        };
        this.http.getRequestWithHeader('configurations/list', httpOptions).subscribe(
            res => {
                console.log(res);

                if(res['message'] == 'error_occured'){

                    this.showLoader = false;
        
                    this.http.onEnd();
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = res['exp']['message'];
        
                    this.dialogRef.afterClosed().subscribe(result => {
                        window.location.href = '#/app/configs/list';
                    });
                    return;
                 }


                const report_json = res['dataMap'];
                console.log(report_json);                  
                 let items = report_json['configurationsList'];//list of countries
                 var result = {'offSet':0,'limit':0,'items':items};

                 this.saveDashboardData(result,filter);
                this.http.onEnd();
                this.showLoader = false;

                },
                err => {
                    this.dialogRef = this.dialog.open(dialogComponent);
                    this.dialogRef.componentInstance.msg = 'Failed to retrieve data.';
                    this.showLoader = false;
                    this.http.onEnd();
                    }
        );  
    }

    public saveDashboardData(res,filter)//res has countrylist 
     {
            if(res && Object.keys(res).length > 0 ){
                this.dashboardData = res;
                this.rows=[];
                this.rows['offSet'] = res.offSet;
                if(this.dashboardData && Object.keys(this.dashboardData).length > 0 ) {
                    if(this.dashboardData['items']) {
                        let totalCount = 0;
                    if(parseInt(res.offSet) == 0) {
                        localStorage.setItem('totalCount',res.itemCount);
                        totalCount = parseInt(res.itemCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }
                    this.rows['total_count'] = totalCount;
                    for (let data in this.dashboardData['items']) {
                       
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.dashboardData['items'][data]['id'];
                            this.rows[data]['downloadLimit'] = this.dashboardData['items'][data]['downloadLimit'];
                            this.rows[data]['passwordExpiryDays'] = this.dashboardData['items'][data]['passwordExpiryDays'];
                            this.rows[data]['country'] = this.dashboardData['items'][data]["country"];
                        }
                    this.showTable = true;
                    this.showLoader = false;
                    this.temp = this.rows;
                    }
                }

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offSet' && f !='total_count' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offSet'){
                        finalRows['offSet'] = this.rows['offSet'];
                    }
                    if(f == 'total_count'){
                        finalRows['total_count'] = this.rows['total_count'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offSet']/this.page.size },finalRows,filter);
                this.http.onEnd();
            }
    }


    /**
    * Populate the table with new data based on the page number
    * @param page The page to select
    */
    setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
            if(rows.length != 0){
                this.serverResultsService.getResults(this.page,rows).subscribe(pagedData => {
                    this.page = pagedData.page;
                    this.tableRows = pagedData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getDashboardData(this.filters);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }
  
      
public getLastWeek(){
    var today = new Date();
    var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    return lastWeek ;
}


public rowToDelete(configId){
    this.rowToDel = configId;
}

public deleteConfiguration(){

    if(this.rowToDel == null){
        return;
    }




    const config = {'id':this.rowToDel};
    console.log(config);

    // let body = JSON.stringify(user);
    this.showLoader = true;

    let token = localStorage.getItem('userEmail');
    const httpOptions = {
      headers : new HttpHeaders({
            'Content-Type': 'application/json',
            // 'googleEmailId': token
            'Authorization': `Bearer ${this.accessToken}`
        }) };
    this.http.postRequestWithHeader(config,'configurations/delete',httpOptions).subscribe(
        res => { this.deleteConfigResponse(res); 
        
        },
        err => { this.http.onEnd(); 
            this.showLoader = false;
            this.rowToDel = null;
        }
    );
 }

 public deleteConfigResponse(res) {
    this.rowToDel = null;
    // var res = JSON.parse(res['_body']);
        if(res && res.message == 'success'){
          
            this.showLoader = false;

            this.http.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
           
                this.dialogRef.componentInstance.msg = "Configuration Deleted Successfully.";
            this.dialogRef.afterClosed().subscribe(result => {
            this.reloadData();
            });
        }else if(res && res.message == 'error_occured'){

            this.showLoader = false;

            this.http.onEnd();
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.exp.message;

        
         } else {
            this.showLoader = false;

            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Not able to perform action. Please try again.';
            this.http.onEnd();
        }
    }

  
 ngOnInit(){
    this.APPCONFIG =APPCONFIG;
 }
    

}



